// extracted by mini-css-extract-plugin
export default {"main":"FirstScreen_main__OmR8Z","router":"FirstScreen_router__AJis2"};